import { useMemo, type CSSProperties } from 'react';
import { getTimezoneLabel } from '../utils/timezone';

interface TimezoneBannerProps {
  /** Optional prefix override; defaults to "All times shown in your local timezone". */
  prefix?: string;
  className?: string;
  style?: CSSProperties;
}

/**
 * Small inline notice that confirms which timezone the user is viewing. Drops next to date inputs
 * and calendar headers so operators don't have to guess whether a value is UTC or local.
 */
export function TimezoneBanner({
  prefix = 'All times shown in your local timezone',
  className,
  style
}: TimezoneBannerProps) {
  const label = useMemo(() => getTimezoneLabel(), []);
  return (
    <div
      role="note"
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.4rem',
        padding: '0.25rem 0.625rem',
        borderRadius: 999,
        background: 'var(--ops-surface-2, #f1f5f9)',
        border: '1px solid var(--ops-border, #e2e8f0)',
        color: 'var(--ops-color-muted, #475569)',
        fontSize: 12,
        fontWeight: 500,
        ...style
      }}
    >
      <span aria-hidden style={{ fontSize: 14 }}>{'\u{1F551}'}</span>
      <span>
        {prefix}: <strong style={{ color: 'inherit' }}>{label}</strong>
      </span>
    </div>
  );
}
